import type { NexaLayout } from "../constants";

const OPTIONS: { key: NexaLayout; label: string; d: string }[] = [
  { key: "floating", label: "Floating", d: "M2.4 3h11.2v10H2.4ZM2.4 6h11.2" },
  { key: "sidebar", label: "Sidebar", d: "M2.4 3h11.2v10H2.4ZM10 3v10" },
  { key: "fullscreen", label: "Full screen", d: "M2.6 6V2.6h3.4M13.4 6V2.6H10M2.6 10v3.4h3.4M13.4 10v3.4H10" },
];

const LayoutMenu = ({ active, onPick }: { active: NexaLayout; onPick: (layout: NexaLayout) => void }) => (
  <div className="tw-absolute tw-right-2 tw-top-11 tw-z-[60] tw-w-52 tw-rounded-xl tw-border tw-border-[#E4E1F0] tw-bg-white tw-p-1.5 tw-shadow-lg">
    <div className="tw-px-2.5 tw-py-1.5 tw-text-label-xs tw-font-semibold tw-text-gray-500">Switch to</div>
    {OPTIONS.map((option) => (
      <button
        key={option.key}
        type="button"
        onClick={() => onPick(option.key)}
        className={`tw-flex tw-w-full tw-items-center tw-gap-2.5 tw-rounded-lg tw-px-2.5 tw-py-2 tw-text-left tw-text-label-sm hover:tw-bg-gray-50 ${
          option.key === active ? "tw-bg-[#EEF0FE] tw-font-semibold tw-text-[#3730A3]" : "tw-text-[#3B3960]"
        }`}
      >
        <svg width="15" height="15" viewBox="0 0 16 16" fill="none" aria-hidden="true" className="tw-shrink-0">
          <path d={option.d} stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
        <span className="tw-flex-1">{option.label}</span>
        {option.key === active && <span aria-hidden="true">✓</span>}
      </button>
    ))}
  </div>
);

export default LayoutMenu;
